module.exports = __webpack_public_path__ + "191206_Okko_deisel_Morj_15s_new_legal.mp4?d8dcf8c76734870e53ee6f87c48f3181";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/191206_Okko_deisel_Morj_15s_new_legal.mp4
// module id = 148
// module chunks = 0